/**
 * POSHEY Homepage - Interactive Components
 * Replaces Replo runtime for: Carousel, Marquee, Accordion/Collapsible
 */

(function() {
  'use strict';

  // =====================================================
  // CAROUSEL (Reviews)
  // =====================================================
  function initCarousels() {
    document.querySelectorAll('[data-replo-carousel]').forEach(function(carousel) {
      if (carousel.dataset.carouselInit) return;
      carousel.dataset.carouselInit = 'true';

      var slidesRegion = carousel.querySelector('[data-replo-part="slides"]');
      if (!slidesRegion) slidesRegion = carousel.querySelector('[aria-label="Carousel slides"]');
      if (!slidesRegion) return;
      var track = slidesRegion.querySelector('[data-replo-part="slide-track"]');
      if (!track) track = slidesRegion.querySelector(':scope > div');
      if (!track) return;

      var allSlides = Array.from(track.querySelectorAll('[data-replo-part="slide"]'));
      if (allSlides.length === 0) allSlides = Array.from(track.children);
      
      // Identify real vs clone slides using data-slide-source-index
      // Clones have duplicate source indices. Find unique source indices.
      var realSlideCount = 0;
      var sourceIndices = {};
      allSlides.forEach(function(s) {
        var si = s.getAttribute('data-slide-source-index');
        if (si !== null && !sourceIndices[si]) {
          sourceIndices[si] = true;
          realSlideCount++;
        }
      });
      if (realSlideCount === 0) realSlideCount = allSlides.length;
      
      // Find the first real slide (source-index 0, not a clone)
      var firstRealIndex = 0;
      for (var i = 0; i < allSlides.length; i++) {
        if (allSlides[i].getAttribute('data-slide-index') === '0') {
          firstRealIndex = i;
          break;
        }
      }
      
      var currentSlide = 0; // 0-based index into real slides
      var dots = carousel.querySelectorAll('[aria-label^="Go to slide"]');
      
      var prevBtn = null, nextBtn = null;
      carousel.querySelectorAll('[role="button"]').forEach(function(btn) {
        var label = btn.getAttribute('aria-label') || '';
        if (!label.startsWith('Go to slide')) {
          if (!prevBtn) prevBtn = btn;
          else if (!nextBtn) nextBtn = btn;
        }
      });

      function getSlideWidth() {
        if (!allSlides[0]) return 0;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        return allSlides[0].offsetWidth + gap;
      }

      function goToSlide(idx, animate) {
        if (animate === undefined) animate = true;
        // Wrap around real slides
        idx = ((idx % realSlideCount) + realSlideCount) % realSlideCount;
        currentSlide = idx;
        
        // The actual track position = firstRealIndex + currentSlide
        var trackIdx = firstRealIndex + currentSlide;
        var sw = getSlideWidth();
        
        track.style.transitionProperty = animate ? 'transform' : 'none';
        track.style.transitionDuration = animate ? '400ms' : '0ms';
        track.style.transitionTimingFunction = 'ease-out';
        track.style.transform = 'translate3d(' + (-trackIdx * sw) + 'px, 0, 0)';
        
        // Update dots
        dots.forEach(function(d, i) {
          var isActive = i === currentSlide;
          if (isActive && !d.classList.contains('r-w6rz0p')) {
            d.classList.add('r-w6rz0p');
          } else if (!isActive && d.classList.contains('r-w6rz0p')) {
            d.classList.remove('r-w6rz0p');
          }
          d.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
        
        // Update active states on slides
        allSlides.forEach(function(s) {
          var si = parseInt(s.getAttribute('data-slide-source-index') || '-1');
          if (si === currentSlide) {
            s.setAttribute('data-is-active', 'true');
          } else {
            s.removeAttribute('data-is-active');
          }
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentSlide - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentSlide + 1); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() { goToSlide(i); });
      });

      // Auto-advance every 5s
      var autoTimer = setInterval(function() { goToSlide(currentSlide + 1); }, 5000);
      carousel.addEventListener('mouseenter', function() { clearInterval(autoTimer); });
      carousel.addEventListener('mouseleave', function() {
        autoTimer = setInterval(function() { goToSlide(currentSlide + 1); }, 5000);
      });

      // Touch/swipe
      var touchStartX = 0, touchStartY = 0;
      track.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, {passive: true});
      track.addEventListener('touchend', function(e) {
        var dx = touchStartX - e.changedTouches[0].clientX;
        var dy = touchStartY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
          goToSlide(currentSlide + (dx > 0 ? 1 : -1));
        }
      }, {passive: true});

      // Initialize to slide 0 without animation
      goToSlide(0, false);
    });
  }

  // =====================================================
  // MARQUEE
  // =====================================================
  function initMarquees() {
    var allEls = document.querySelectorAll('*');
    allEls.forEach(function(el) {
      if (el.dataset.marqueeInit) return;
      var cs = getComputedStyle(el);
      var anim = cs.animationName || '';
      if (anim.indexOf('marquee') === -1) return;
      el.dataset.marqueeInit = 'true';
      var totalWidth = el.scrollWidth;
      el.style.setProperty('--replo-marquee-width', totalWidth + 'px');
    });
  }

  // =====================================================
  // COLLAPSIBLE / ACCORDION
  // =====================================================
  function initCollapsibles() {
    document.querySelectorAll('[data-replo-collapsible]').forEach(function(collapsible) {
      if (collapsible.dataset.collapsibleInit) return;
      collapsible.dataset.collapsibleInit = 'true';

      var trigger = collapsible.querySelector('[role="button"]');
      if (!trigger) return;
      var contentId = trigger.getAttribute('aria-controls');
      var content = contentId ? document.getElementById(contentId) : null;
      if (!content) return;

      trigger.addEventListener('click', function() {
        var isOpen = collapsible.getAttribute('data-state') === 'open';
        collapsible.setAttribute('data-state', isOpen ? 'closed' : 'open');
        trigger.setAttribute('aria-expanded', String(!isOpen));

        if (isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          requestAnimationFrame(function() {
            content.style.maxHeight = '0';
            content.style.overflow = 'hidden';
            content.style.transition = 'max-height 300ms ease';
          });
          setTimeout(function() {
            content.setAttribute('hidden', '');
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
          }, 300);
        } else {
          content.removeAttribute('hidden');
          content.style.maxHeight = '0';
          content.style.overflow = 'hidden';
          content.style.transition = 'max-height 300ms ease';
          requestAnimationFrame(function() {
            content.style.maxHeight = content.scrollHeight + 'px';
          });
          setTimeout(function() {
            content.style.maxHeight = '';
            content.style.overflow = '';
            content.style.transition = '';
          }, 300);
        }

        var icon = trigger.querySelector('[aria-hidden="true"]');
        if (icon) {
          icon.style.transition = 'transform 300ms ease';
          icon.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
        }
      });

      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          trigger.click();
        }
      });
    });
  }

  // =====================================================
  // INIT
  // =====================================================
  function init() {
    initCarousels();
    initMarquees();
    initCollapsibles();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('[data-marquee-init]').forEach(function(el) {
        delete el.dataset.marqueeInit;
      });
      initMarquees();
    }, 250);
  });
})();
